export default "__VITE_ASSET__Dzwh0Ma2__"